import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Insights from "./pages/Insights";
import Capabilities from "./pages/Capabilities";
import Magazine from "./pages/Magazine";
import BLounge from "./pages/BLounge";
import Studio from "./pages/Studio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Impressum from "./pages/Impressum";
import { Toaster } from "./components/ui/toaster";
import { I18nProvider } from "./i18n/I18nContext";

function App() {
  return (
    <I18nProvider>
      <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/capabilities" element={<Capabilities />} />
            <Route path="/magazine" element={<Magazine />} />
            <Route path="/blounge" element={<BLounge />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
    </I18nProvider>
  );
}

export default App;
